import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import './MobileMenu.css';
// import MobileMenuSearch from '../components/MobileMenuSearch';

class MobileMenu extends Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.handleClick = this.handleClick.bind(this);
  }

  handleClick() {
    this.props.toggleMobileMenu();
  }

  render() {
    const { location } = this.props;
    return (
      <aside id="mobileMenu" className={`menu mobile-menu ${this.props.active ? 'is-active' : ''}`}>
        <ul className="menu-list">
          <li className={location.pathname.indexOf('about') !== -1 ? 'is-active' : ''}>
            <Link to="/about/us" onClick={this.handleClick}>
              關於我們
            </Link>
          </li>
          <li className={location.pathname.indexOf('catalog') !== -1 ? 'is-active' : ''}>
            <Link to="/catalog/1" onClick={this.handleClick}>
              產品介紹
            </Link>
          </li>
          <li className={location.pathname.indexOf('locations') !== -1 ? 'is-active' : ''}>
            <Link to="/locations" onClick={this.handleClick}>
              銷售據點
            </Link>
          </li>
          <li className={location.pathname.indexOf('register') !== -1 ? 'is-active' : ''}>
            <Link to="/register" onClick={this.handleClick}>
              產品登錄
            </Link>
          </li>
          <li className={location.pathname.indexOf('news') !== -1 ? 'is-active' : ''}>
            <Link to="/news/all" onClick={this.handleClick}>
              最新消息
            </Link>
          </li>
          <li className={location.pathname.indexOf('contact') !== -1 ? 'is-active' : ''}>
            <Link to="/contact/taipei" onClick={this.handleClick}>
              聯絡我們
            </Link>
          </li>
          {/* <li>
            <Route
              render={properties => (
                <MobileMenuSearch toggleMobileMenu={this.props.toggleMobileMenu} {...properties} />
              )}
            />
          </li> */}
        </ul>
      </aside>
    );
  }
}

MobileMenu.propTypes = {
  active: PropTypes.bool.isRequired,
  toggleMobileMenu: PropTypes.func.isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }),
};

MobileMenu.defaultProps = {
  location: {
    pathname: '',
  },
};

export default MobileMenu;



// WEBPACK FOOTER //
// ./src/components/MobileMenu.js